import React, { useEffect, useRef, useState } from "react";
import './SideBar.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row } from "react-bootstrap";
import { getChatService, getHistoryListService, messageActionService, sendMessageService } from "../../services/chatService";
import CustomImage from '../../CommonComponents/CustomImage';
import sendImg from '../../Asset/image/SendImg.png';
import chatAvatar from '../../Asset/image/avatar.png';
import likeB from '../../Asset/image/like-active.png';
import likeI from '../../Asset/image/like.png';
import dislikeI from '../../Asset/image/dis_like.png';
import dislikeB from '../../Asset/image/dis_like_active.png';
import saveI from '../../Asset/image/save.png';
import saveB from '../../Asset/image/save_active.png';
import deleteB from '../../Asset/image/delete_white.png';
import shareB from '../../Asset/image/share.png';
import Guest from '../../Asset/image/blank_profile.png';
import { formatAMPM, formatChatDate, formatNewDate, isEmpty, messageActionOption, paginationLimit, paginationStartFrom, signUpType } from "../../data/constants";
import { toast } from "react-toastify";
import { RWebShare } from "react-web-share";
import { getUserDetailService } from "../../services/userService";
import ApiConfig from "../../config/ApiConfig";
import { useAuth } from "../../Context/AuthProvider";
import Loader from "../../CommonComponents/Loader";
import InfiniteScroll from 'react-infinite-scroll-component';
import LogoutModal from "../../CommonComponents/LogoutModal";

function ChatComponent({ formality, promptFilter, tone, categoryKey, replyLanguage, getList }) {
    const { user, logout } = useAuth()
    const [chatDetail, setChatDetail] = useState([]);
    const [validated, setValidated] = useState(false);
    const [userImage, setUserImage] = useState(Guest);
    const [isLoading, setLoader] = useState(false);
    const [isLoadMoreCalled, setIsLoadMoreCalled] = useState(true);
    const [isLoading1, setLoader1] = useState(false);
    const [sendMsg, setSendMsg] = useState("");
    const [professionalMsg, setProfessionalMsg] = useState("");
    const [personalMsg, setPersonalMsg] = useState("");
    const [error, setError] = useState({});
    const [page, setPage] = useState(1);
    const [deleteShow, setDeleteShow] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const handleDeleteShow = () => setDeleteShow(true);
    const [categoryChange, setCategoryChange] = useState('');
    const ref = useRef(null);
    useEffect(() => {
        if (user?.signuptype == signUpType?.guest) {
            setChatDetail([]);
        } else {
            setChatDetail([]);
            setPage(1)
            setError({});
            setLoader1(true)
            setIsLoadMoreCalled(true)
            setProfessionalMsg('');
            setPersonalMsg('')
            setSendMsg('')
            setCategoryChange(categoryKey)
        }
    }, [categoryKey])

    useEffect(() => {
        if (user?.signuptype !== signUpType?.guest && categoryChange) {
            getChat(page);
        }
    }, [categoryChange])

    const renderLoader = () => {
        return (
            <Loader
                visible={false}
                emptyTextKey={'AskAnything'}
                style={{ top: 0, position: "relative" }} />
        )
    }
    const getChat = async (crPage = 1) => {
        try {
            setLoader1(false);
            const params = {
                "categorykey": categoryKey,
                "numberofdocs": paginationLimit,
                "currentpage": crPage,
            };
            const response = await getChatService(params);
            if (response?.data) {
                setLoader1(false);
                if (response?.data?.length <= paginationLimit) {
                    setIsLoadMoreCalled(false)
                }
                else {
                    if (chatDetail?.length && crPage == 1) {
                        setChatDetail(prevItems => {
                            let prevUpdate = [...prevItems];
                            // prevUpdate.splice(prevUpdate.length - 2, 2)
                            return [response?.data?.data[0], response?.data?.data[1], ...prevUpdate]
                        });
                    }
                    else {
                        setChatDetail(prevItems => [...prevItems, ...response?.data?.data]);

                        if ((chatDetail?.length && crPage !== 1) || (!chatDetail?.length && crPage == 1)) {
                            setPage(prevPage => prevPage + 1);
                            // alert('hello')
                        }
                    }
                }
            }
            else {
                console.log("error");
                setLoader1(false);
            }
        } catch (error) {
            logout();
            console.log(error, error?.response);
        }
    }
    useEffect(() => {
        if (user?.profilePicture) {
            setUserImage(ApiConfig.BASE_IMAGE_URL + user?.profilePicture + ".jpg" + "?" + new Date().getTime());
        }
        else {
            setUserImage("")
        }
    }, [user])

    const messageAction = async (messageDetail, action, params) => {
        try {
            const response = await messageActionService(params, action);
            if (response?.data) {
                updateMessages(messageDetail, action);
                getChat(page);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const updateMessages = (messageDetail, action) => {
        let messagesDefault = chatDetail;
        let messageResult = [];
        if (action === messageActionOption?.like) {
            messageResult = messagesDefault?.map((item) => {
                if (messageDetail?._id === item._id) {
                    item.isLike = !item.isLike;
                    item.isDisLike = item.isLike ? false : item.disLike;
                }
                return item;
            });
        } else if (action === messageActionOption.disLike) {
            messageResult = messagesDefault?.map((item) => {
                if (messageDetail?._id === item._id) {
                    item.isDisLike = !item.isDisLike;
                    item.isLike = item.isDisLike ? false : item.isLike;
                }
                return item;
            });
        } else if (action === messageActionOption?.save) {
            messageResult = messagesDefault?.map((item) => {
                if (messageDetail?._id === item._id) {
                    item.isSave = !item.isSave;
                }
                return item;
            });
            getList();
        } else if (action === messageActionOption?.unSave) {
            messageResult = messagesDefault?.map((item) => {
                if (messageDetail?._id === item._id) {
                    item.isSave = !item.isSave;
                }
                return item;
            });
            getList();
        } else if (action === messageActionOption?.translator) {
            messageResult = messagesDefault?.map((item) => {
                if (messageDetail?._id === item._id) {
                    item.translator = !item.translator;
                }
                return item;
            });
        } else if (action === messageActionOption?.delete) {
            messageResult = messagesDefault?.filter((item) => {
                if (messageDetail?._id !== item._id) {
                    return item;
                }
            });
            getList();
        }
        // getChat(page);
        setChatDetail(messageResult);
    };
    const manageMessageAction = (action, messageDetail) => {
        let params = {
            id: messageDetail._id,
        };
        if (action === messageActionOption?.like) {
            params.likestatus = !messageDetail?.isLike;
            params.dislikestatus =
                !messageDetail?.isLike && messageDetail?.isDisLike
                    ? false
                    : messageDetail?.isDisLike;
            messageAction(messageDetail, messageActionOption?.like, params);
        } else if (action === messageActionOption?.disLike) {
            params.likestatus =
                !messageDetail?.isDisLike && messageDetail?.isLike
                    ? false
                    : messageDetail?.isLike;
            params.dislikestatus = !messageDetail?.isDisLike;
            messageAction(messageDetail, messageActionOption?.disLike, params);
        } else if (action === messageActionOption?.save) {
            params = { messageid: params.id };
            messageAction(messageDetail, messageActionOption?.save, params);
            toast.success("Message saved successfully!");
        } else if (action === messageActionOption?.unSave) {
            params = { messageid: params.id };
            messageAction(messageDetail, messageActionOption?.unSave, params);
        } else if (action === messageActionOption?.translator) {
            messageAction(messageDetail, messageActionOption?.translator, params);
            // } else if (action === messageActionOption.share) {
            //     toast.success(messageDetail.text);
        } else if (action === messageActionOption?.delete) {
            params = { messageid: params.id };
            messageAction(messageDetail, messageActionOption?.delete, params);
            setDeleteShow(false);
        } else {
            console.log('Invalid message action type');
        }
        getChat(page);
    };
    const checkValidation = () => {
        try {
            let isValid = true;
            let errors = error;
            if (categoryKey !== "resume") {
                if (!sendMsg || isEmpty(sendMsg)) {
                    isValid = false;
                    errors = { ...errors, sendMsg: true }
                }
            }
            else {
                if (!personalMsg || isEmpty(personalMsg)) {
                    isValid = false;
                    errors = { ...errors, personalMsg: true }
                }
                if (!professionalMsg || isEmpty(professionalMsg)) {
                    isValid = false;
                    errors = { ...errors, professionalMsg: true }
                }
            }
            setError(errors)
            return isValid;
        } catch (error) {
            console.log(error)
        }
    }

    const removeSpace = (message) => {
        let data = message.split("\n\n");
        return data[1]
    }
    const renderError = (msg, value, style) => {
        return (
            value ? (
                <h6 className="blog_error_text4 signUpMsg12 " style={{ marginBottom: -5, marginTop: style !== undefined ? 5 : 0 }}>
                    {msg}
                </h6>) : null)
    }
    const onEnterPress = (e) => {
        if (e.keyCode === 13) {
            sendChat(e);
        }
    };
    const separateResume = (data) => {
        let newData = data.split("@abc/")
        return "Profile:\n" + newData[0] + '\nJob Description:\n' + newData[1];
    };
    const sendChat = async (e) => {
        e.preventDefault();
        if (user?.signuptype == signUpType?.guest) {
            toast.error(
                'Please register to continue further, currently you are a guest user.',
            );
            setLoader(false);
            return;
        }
        else {
            // if (user.packType == 1 || user.packType == 2) {
            try {
                if (!checkValidation()) {
                    return;
                }
                setLoader(true);
                const params = {
                    "message": categoryKey == "resume" ? personalMsg + "@abc/" + professionalMsg : sendMsg,
                    "category_key": categoryKey,
                    "replyIn": replyLanguage,
                    "tone": tone,
                    "formality": formality,
                    "promptfilter": promptFilter,
                };
                ref.current.scrollTo(0, ref.current.scrollHeight);
                const response = await sendMessageService(params);
                if (response?.data) {
                    // const data = messages;
                    getChat();
                    setSendMsg("");
                    setPersonalMsg("");
                    setProfessionalMsg("");
                    // toast.success("Generating result...")
                    setLoader(false);
                }
                else {
                    console.log("Error")
                }
            } catch {
                setError({ ...error, sendMsg: true })
                setLoader(false);
            }
        }
    }

    return (
        <Container fluid className="py-2" >
            <div className="wrapper">
                <div id="scrollableDiv" className="memlist_scroll spacing_scroll" ref={ref} style={{ overflowY: 'auto' }}>
                    {/* <Row className="d-flex justify-content-center"> */}
                    <InfiniteScroll
                        dataLength={chatDetail?.length}
                        next={() => { getChat(page) }}
                        style={{ display: 'flex', flexDirection: 'column-reverse' }} //To put endMessage and loader to the top.
                        inverse={true} //
                        hasMore={isLoadMoreCalled && !isLoading1}
                        // loader={<h4>Loading...</h4>}
                        scrollableTarget="scrollableDiv"
                    >
                        {!chatDetail?.length ? renderLoader() : [...chatDetail]?.map((item, index) => {
                            return (
                                <>
                                    <div className="scrollbar position-relative" key={index} style={{ wordBreak: 'break-all' }} >
                                        {item.message_from === "user" ?
                                            <div className="d-flex flex-row justify-content-end mb-4 pt-1" >
                                                <div>
                                                    <pre className="small p-2 me-3 mb-1 text-white rounded-3 sub-header1" style={{
                                                        background: "#464255", display: "flex", justifyContent: "space-between", whiteSpace: 'pre-wrap', wordBreak: 'break-word'
                                                    }}>
                                                        {categoryKey === "resume" ? separateResume(item.message) : item.message}
                                                        <span onClick={() => { handleDeleteShow(); setSelectedMessage(item) }}>
                                                            <CustomImage className="message_icon" src={deleteB} />
                                                        </span>
                                                    </pre>

                                                    <p className="small me-3 mb-3 rounded-3 text-muted d-flex justify-content-end">
                                                        {new Date(item.createdAt).getDate() === new Date().getDate() ? "Today" + "  " + formatAMPM(item?.createdAt) : formatChatDate(new Date(item?.createdAt)) + "  " + formatAMPM(item?.createdAt)}
                                                    </p>
                                                </div>
                                                <CustomImage src={userImage ? userImage : Guest} style={{ width: "35px", height: "35px", borderRadius: "15px" }} />
                                            </div>
                                            :
                                            <div className="d-flex flex-row justify-content-start " >
                                                <CustomImage src={chatAvatar} style={{ width: "45px", height: "100%" }} />
                                                <div >
                                                    <pre className="small ps-2 ms-3 mb-1 rounded-3 sub-header1"
                                                        style={{ backgroundColor: " #0074FE", color: "white", whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                        <span style={{ display: "flex", alignItems: "center", marginTop: "-30px" }}>{item.message}</span>
                                                        <div className="d-flex justify-content-between">
                                                            <div>
                                                                <CustomImage className="message_icon" onClick={() => { manageMessageAction("like", item); }} src={item?.isLike === true ? likeB : likeI} />
                                                                <CustomImage className="message_icon" onClick={() => { manageMessageAction("disLike", item) }} src={item?.isDisLike === true ? dislikeB : dislikeI} />

                                                            </div>
                                                            <div>
                                                                <CustomImage className="message_icon" onClick={() => {
                                                                    if (item?.isSave === true)
                                                                        manageMessageAction("unSave", item);
                                                                    else
                                                                        manageMessageAction("save", item)
                                                                }} src={item?.isSave === true ? saveB : saveI} />
                                                                <RWebShare
                                                                    data={{
                                                                        text: "Share Tamara chat",
                                                                        url: "https://tamara.tech",
                                                                        title: "Tamara Chat",
                                                                    }}
                                                                // onClick={() => console.log("shared successfully!")}
                                                                >
                                                                    <CustomImage className="message_icon" src={shareB} />
                                                                </RWebShare>
                                                                <CustomImage className="message_icon" onClick={() => { handleDeleteShow(); setSelectedMessage(item) }} src={deleteB} />
                                                            </div>
                                                        </div>
                                                    </pre>
                                                    <p className="small ms-3 mb-3 rounded-3 text-muted">
                                                        {new Date(item?.createdAt).getDate() === new Date().getDate() ? "Today" + "  " + formatAMPM(item?.createdAt) : formatChatDate(new Date(item?.createdAt)) + "  " + formatAMPM(item?.createdAt)}
                                                    </p>

                                                </div>
                                            </div>
                                        }

                                    </div >
                                </>
                            )
                        })}
                    </InfiniteScroll>
                    {/* </Row> */}

                </div>
                <LogoutModal show={deleteShow} setShow={setDeleteShow} title="Delete" data="delete this message" onYesClick={() => manageMessageAction("delete", selectedMessage)} />
                <Form noValidate validated={validated} onSubmit={sendChat} onKeyDown={categoryKey !== "resume" ? onEnterPress : null} >
                    <div className="d-flex position-relative mt-2">
                        {/* <div style={{ position: 'absolute', bottom: -80, width: "98%" }}> */}
                        <div className="" style={{ flex: 1 }}  >
                            <Form.Group controlId="exampleForm.ControlInput1 ">
                                {categoryKey !== "resume" ?
                                    <Form.Control
                                        type="text"
                                        as="textarea"
                                        rows={4}
                                        resize
                                        placeholder="Type your query here..."
                                        className="send-box p-1 mt-0"
                                        value={sendMsg}
                                        disabled={isLoading}
                                        onChange={(e) => { setSendMsg(e.target.value); setError({ ...error, sendMsg: false }); setLoader(false); }}
                                    // autoFocus
                                    />
                                    :
                                    <>
                                        <Form.Control
                                            type="text"
                                            as="textarea"
                                            rows={2}
                                            resize
                                            placeholder="Type profile details here..."
                                            className="send-box p-1 mt-0"
                                            value={personalMsg}
                                            disabled={isLoading}
                                            onChange={(e) => { setPersonalMsg(e.target.value); setError({ ...error, personalMsg: false }); setLoader(false); }}
                                        // autoFocus
                                        />
                                        <Form.Control
                                            type="text"
                                            as="textarea"
                                            rows={2}
                                            resize
                                            placeholder="Type job description here..."
                                            className="send-box p-1 mt-1"
                                            value={professionalMsg}
                                            disabled={isLoading}
                                            onChange={(e) => { setProfessionalMsg(e.target.value); setError({ ...error, professionalMsg: false }); setLoader(false); }}
                                        // autoFocus
                                        />
                                    </>}
                            </Form.Group>
                        </div>
                        <div className="d-flex align-items-end"  >
                            <Button type='submit' className='submit_button  d-flex justify-content-center ms-3' disabled={isLoading} style={{
                                height: "40px",
                                // width: "80px",
                                // position: 'absolute',
                                // bottom: 7,
                                // right: 10, display: "flex", justifyContent: "center",
                            }}>
                                {isLoading ? (
                                    <center>
                                        <div
                                            style={{ width: "1rem", height: "1rem", color: "#1f7e78" }}
                                            class="spinner-border me-2 "
                                            role="status"
                                        />
                                    </center>) : <CustomImage className="iconStyle me-2" src={sendImg} />}<span className="d-none d-lg-block" style={isLoading ? { pointerEvent: 'none' } : {}} >Send</span></Button>

                        </div>
                    </div>
                    {renderError('Write something first! ', error.sendMsg)}
                    {renderError('Please enter profile details and job description both! ', error.personalMsg || error.professionalMsg)}
                    {/* {renderError('Please enter job description! ', error.professionalMsg)} */}
                </Form >
            </div>
        </Container >
    );
}
export default ChatComponent;